import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserFieldService {
  // Create a private BehaviorSubject to hold the selectedUserFieldId
  private selectedUserFieldIdSubject = new BehaviorSubject<number | null>(null);
  // Expose the selectedUserFieldId as an observable for components to subscribe to
  selectedUserFieldId$ = this.selectedUserFieldIdSubject.asObservable();

  private selectedGrowerSubject = new BehaviorSubject<string | null>(null);
  selectedGrower$ = this.selectedGrowerSubject.asObservable();

  private selectedEntitySubject = new BehaviorSubject<string | null>(null);
  selectedEntity$ = this.selectedEntitySubject.asObservable();

  // Method to update the selectedUserFieldId
  setSelectedUserFieldId(id: number): void {
    this.selectedUserFieldIdSubject.next(id);
  }

  // Method to update the selectedGrower, passing parameter growerName
  setSelectedGrower(growerName: string): void {
    this.selectedGrowerSubject.next(growerName);
  }

  // Method to update the selectedEntity, passing parameter entityName
  setSelectedEntity(entityName: string): void {
    this.selectedEntitySubject.next(entityName);
  }
}
